import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import { useOktaAuth } from "@okta/okta-react";

const Layout = (props: any) => {
    const { authState } = useOktaAuth();
    const [isAuthenticated, setAuthenticated] = useState(localStorage.getItem('okta-token-storage') !== null);

    //useEffect(() => {
    //    console.log(authState);
    //    if (authState !== null && !authState.isAuthenticated) {
    //        localStorage.removeItem('authenticated');
    //        //history.push('/');
    //    }
    //}, []);

    return (
        <React.Fragment>
            {
                isAuthenticated &&
                (<NavMenu />)
            }
            
            <Container fluid>
                {props.children}
            </Container>
        </React.Fragment>
    );
}

export default Layout;